import { colors } from '@app/providers/config-provider/lib/theme'
import type { CheckboxProps as AntdCheckboxProps } from 'antd'
import { Checkbox as AntdCheckbox, ConfigProvider } from 'antd'

export const Checkbox = (props: AntdCheckboxProps) => {
    return (
        <ConfigProvider
            theme={{
                token: { colorBorder: colors.checkboxBorderColor }
            }}
        >
            <AntdCheckbox {...props} />
        </ConfigProvider>
    )
}
